import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { Read, ReadResult } from '../models/read';
import { EntityType } from '../models/entity-type.enum';

import {
  AvionBusinessEntity,
  ExecuteQueryResult,
  ListResult,
  SystemCheckSumsResult,
} from '../models/common';
import { Save, SaveList, SaveListResult, SaveResult } from '../models/save';
import { BASE_URL } from '../../core/global/config';

@Injectable({
  providedIn: 'root',
})
export class CommonApiService {
  private baseUrl = inject(BASE_URL);
  private http = inject(HttpClient);

  public read<T>(entityId: string, entityType: EntityType, displayId?: number): Observable<ReadResult<T>> {
    const requestData: Read = {} as Read;
    requestData.abe = {
      EntityId: entityId,
      EntityTypeId: entityType,
    };

    if (displayId) {
      requestData.abe.DisplayId = displayId;
    }

    return this.http.post(this.baseUrl + '/api/aegis/Read', requestData) as Observable<ReadResult<T>>;
  }

  public executeQuery<T>(entityType: EntityType, queryArgs: any) {
    const requestData = {
      queryEntityId: entityType,
      queryArgs,
    }

    return this.http.post(this.baseUrl + '/api/aegis/ExecuteQuery', requestData) as Observable<ExecuteQueryResult<T>>;
  }

  public readAll<T>(abe: AvionBusinessEntity, filters?: any): Observable<ListResult<T>> {
    const requestData = {
      abe,
    } as any;

    if (filters) {
      requestData.filters = filters;
    }

    return this.http.post(this.baseUrl + '/api/aegis/ReadAll', requestData) as Observable<ListResult<T>>;
  }

  public listByOwner<T>(entityType: EntityType, entityId: string, entityTypeId: string): Observable<ListResult<T>> {
    const data = {
      entityTypeId: entityType,
      ownerEntityId: entityId,
      ownerEntityTypeId: entityTypeId,
    }

    return this.http.post(this.baseUrl + '/api/aegis/ListByOwner', data) as Observable<ListResult<T>>;
  }

  public getSurveyQuestions<T>(params: any): Observable<ListResult<T>> {
    const data = {
      entityTypeId: params.entityType,
      ownerEntityId: params.ownerEntityId,
      ownerEntityTypeId: params.ownerEntityTypeId,
    } as any;

    if (params.filters) {
      data.filters = params.filters;
    }

    if (params.sortOptions) {
      data.sortOptions = params.sortOptions;
    }

    if (params.pageSize) {
      data.pageSize = params.pageSize;
    }

    if (params.pageNum) {
      data.pageNum = params.pageNum;
    }

    return this.http.post(this.baseUrl + '/api/aegis/ListByOwner', data) as Observable<ListResult<T>>;
  }

  public save<T>(item: T) {
    const abe: T = {...item}

    const requestData: Save<T> = {
      abe: abe,
    };

    return this.http.post(this.baseUrl + '/api/aegis/Save', requestData) as Observable<SaveResult<T>>
  }

  public saveList<T>(items: T[]): Observable<SaveListResult<T>> {
    const requestData: SaveList<T> = {
      abes: items,
    };

    return this.http.post(this.baseUrl + '/api/aegis/SaveList', requestData) as Observable<SaveListResult<T>>;
  }

  public getSystemCheckSums(): Observable<SystemCheckSumsResult> {
    return this.http.post(this.baseUrl + '/api/aria/GetSystemChecksums', {}) as Observable<SystemCheckSumsResult>
  }
}
